/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesSubscriptionLevel } from './WebApiModelsEnumerationTypesSubscriptionLevel';
import {
    WebApiModelsEnumerationTypesSubscriptionLevelFromJSON,
    WebApiModelsEnumerationTypesSubscriptionLevelFromJSONTyped,
    WebApiModelsEnumerationTypesSubscriptionLevelToJSON,
} from './WebApiModelsEnumerationTypesSubscriptionLevel';

/**
 * 
 * @export
 * @interface WebApiAdminDtoCreateUserDto
 */
export interface WebApiAdminDtoCreateUserDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCreateUserDto
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCreateUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCreateUserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCreateUserDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoCreateUserDto
     */
    password?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesSubscriptionLevel}
     * @memberof WebApiAdminDtoCreateUserDto
     */
    subscription?: WebApiModelsEnumerationTypesSubscriptionLevel;
    /**
     * 
     * @type {Date}
     * @memberof WebApiAdminDtoCreateUserDto
     */
    nextRenewal?: Date;
}

/**
 * Check if a given object implements the WebApiAdminDtoCreateUserDto interface.
 */
export function instanceOfWebApiAdminDtoCreateUserDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoCreateUserDtoFromJSON(json: any): WebApiAdminDtoCreateUserDto {
    return WebApiAdminDtoCreateUserDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoCreateUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoCreateUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'subscription': !exists(json, 'subscription') ? undefined : WebApiModelsEnumerationTypesSubscriptionLevelFromJSON(json['subscription']),
        'nextRenewal': !exists(json, 'nextRenewal') ? undefined : (new Date(json['nextRenewal'])),
    };
}

export function WebApiAdminDtoCreateUserDtoToJSON(value?: WebApiAdminDtoCreateUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyName': value.companyName,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'password': value.password,
        'subscription': WebApiModelsEnumerationTypesSubscriptionLevelToJSON(value.subscription),
        'nextRenewal': value.nextRenewal === undefined ? undefined : (value.nextRenewal.toISOString()),
    };
}

